import type { FC, ReactElement } from "react"

import { THEME } from "@/3514/theme"

type TProps = {
    width?: number
    height?: number
    fillColor?: string
    className?: string
}

const Icon: FC<TProps> = ({
    width = 18,
    height = 19,
    fillColor = THEME.COLORS.accentOld,
    className = String("")
}: TProps): ReactElement => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 18 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        style={{ minWidth: `${width}px` }}
    >
        <rect x="1" y="1.5" width="16" height="16" rx="8" stroke={fillColor} strokeWidth="2" />
        <path
            d="M8.44941 10.824L7.88541 5.04H10.1174L9.54141 10.824H8.44941ZM8.02941 13.5V11.58H9.97341V13.5H8.02941Z"
            fill={fillColor}
        />
    </svg>
)

Icon.displayName = "ErrorIcon"

export { Icon as ErrorIcon }
